<template>
  <div class="order-summary-message"
       :title="datetime">
    <p class="m-b-10">Hi, this is the NowServing Pharmacy. This is to confirm your order for:</p>
    
    <div class="order-summary-message__list">
      <div v-for="item in orderSummary.orderitems"
           :key="item.medicineId"
           class="row">
        <span> - {{ item.productName }} #{{ item.quantity }}</span>
        <span>{{ item.unitPrice * item.quantity | currency }}</span>
      </div>
    </div>

    <div class="order-summary-message__totals m-b-10">
      <div class="row">
        <span>Subtotal</span>
        <span>{{ subtotal | currency }}</span>
      </div>
      <div v-if="showVatDiscountValue" class="row">
        <span>Vat Disc.</span>
        <span>- {{ orderSummary.vatdiscount | currency }}</span>
      </div>
      <div v-if="showSalesDiscountValue" class="row">
        <span>Sales Disc.</span>
        <span>-{{ orderSummary.salesdiscount | currency }}</span>
      </div>
      <div class="row">
        <span>Service Fees</span>
        <span>{{ serviceCharge | currency }}</span>
      </div>
      <div class="row">
        <span class="total">TOTAL</span>
        <span>{{ orderSummary.totalamountafterdiscount | currency }}</span>
      </div>
    </div>

    <p class="m-b-10">Orders can be paid through GCash or PayMaya. We will arrange for delivery upon receiving receipt of payment.</p>

    <p class="time">{{ formattedTime }}</p>
  </div>
</template>

<script>
  import {formatDate} from '@/utils/dates';

  export default {
    name: 'order-summary-message',
    props: {
      message: {type: Object, required: true},
    },
    data() {
      return {
        orderSummary: JSON.parse(this.message.msg),
      };
    },
    computed: {
      datetime() {
        return formatDate(this.message.date, 'MMMM D, YYYY hh:mm a');
      },
      formattedTime() {
        return formatDate(this.message.date, 'h:mm a');
      },
      showVatDiscountValue() {
        return this.orderSummary.hasSeniorDiscount && this.orderSummary.vatdiscount !== 0;
      },
      showSalesDiscountValue() {
        return this.orderSummary.hasSeniorDiscount && this.orderSummary.salesdiscount !== 0;
      },
      serviceCharge() {
        const {deliveryfee, fees} = this.orderSummary;
        return (deliveryfee || 0) + (fees || 0);
      },
      subtotal() {
        if (!this.orderSummary || !this.orderSummary.orderitems) return 0;

        return this.orderSummary.orderitems
          .reduce((currentSum, {unitPrice, quantity}) => currentSum + (unitPrice * quantity), 0);
      },
    },
  }
</script>

<style lang="scss">
  .order-summary-message {
    border-radius: radius(medium);
    padding: space(s) space(m);
    background-color: color(gray-50);
    
    .row {
      display: flex;

      &:not(:last-child) {
        margin-bottom: space(s);
      }

      > *:not(:last-child) {
        flex: 1;
        margin-right: space(m);
      }
    }

    &__list {
      margin-bottom: space(m);

      > .row {
        span {
          font-weight: font(bold);
        }
      }
    }

    &__totals {
      margin-bottom: space(m);

      > .row {
        width: 30%;
        margin-left: auto;

        @include responsive(mobile) {
          width: 90%;
        }

        span {
          &.total,
          &:last-child {
            font-weight: font(bold);
          }
        }
      }
    }

    .time {
      font-size: font(s);
    }
  }
</style>
